/**
 * Calm status copy while POS waits on remote override — plan/14.
 */

export type OverrideWaitStatus =
  | "pending"
  | "approved"
  | "denied"
  | "consumed"
  | string;

export function overrideWaitMessage(
  status: OverrideWaitStatus,
  kind: "sale" | "void" = "sale",
): string | null {
  if (status === "pending") {
    return kind === "void"
      ? "Waiting for void approval…"
      : "Waiting for approval…";
  }
  if (status === "approved") {
    return kind === "void"
      ? "Void approved — try Void again"
      : "Override granted — Charge again";
  }
  if (status === "denied") {
    return kind === "void" ? "Void denied" : "Override denied";
  }
  if (status === "consumed") {
    return "Override already used";
  }
  return null;
}
